import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { EmptyLayoutComponent } from './core/layouts/empty/empty-layout.component';
import { DynamicLayoutComponent } from './core/layouts/dynamic/dynamic-layout.component';
import { routes as authenticationRoutes } from './authentication/authentication.module';
import { routes as componentsRoutes } from './components/components.module';
import { routes as tablesRoutes } from './tables/tables.module';
import { routes as teamsRoutes } from './teams/teams-routing.module';

import { ClariNotesComponent } from './clari-notes/clari-notes.component';

import { clariAuthRoutes } from './clari-auth/clari-auth.module';

const routes: Routes = [
  { path: '', redirectTo: 'multi-ai/executive-chat', pathMatch: 'full' },
  { path: 'auth', redirectTo: 'multi-ai/executive-chat', pathMatch: 'full' },

  {
    path: '',
    component: EmptyLayoutComponent,
    children: [
      {
        path: 'auth',
        children: clariAuthRoutes
      }
    ]
  },

  {
    path: '',
    component: DynamicLayoutComponent,
    children: [
      {
        path: 'ai',
        children: authenticationRoutes
      },
      {
        path: 'library',
        children: tablesRoutes
      },
      {
        path: 'iq',
        children: componentsRoutes
      },
      {
        path: 'notes',
        component: ClariNotesComponent
      },
      {
        path: 'multi-ai',
        children: teamsRoutes
      }
    ]
  },

  { path: '**', redirectTo: 'multi-ai/executive-chat', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload',
      initialNavigation: 'enabledBlocking'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
